import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PharmacyTypes, GeneralTypes } from "@/types";

export interface PharmacySearchState {
  pharmacySearchOptions: GeneralTypes.QueryOptions;
  pharmacySearchResults: {
    results: Array<PharmacyTypes.PharmacySearchResult>;
    result_count: string;
  };
}

const DEFAULT_PHARMACY_SEARCH_STATE: PharmacySearchState = {
  pharmacySearchOptions: {
    order_by: [{ npi: GeneralTypes.SortOrder.Asc }],
    page_number: 1,
    results_per_page: 20,
  },
  pharmacySearchResults: {
    results: [],
    result_count: null,
  },
};

export default (state: PharmacySearchState = DEFAULT_PHARMACY_SEARCH_STATE, action: Action): PharmacySearchState => {
  if (action.type === ActionTypes.SEARCH_FOR_PHARMACY_LIST) {
    return {
      ...state,
      pharmacySearchOptions: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_PHARMACY_LIST_RESULTS) {
    return {
      ...state,
      pharmacySearchResults: action.payload,
    };
  } else {
    return state;
  }
};
